/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPagingResponseOfDashboardFileFromDiscriminatorValue, createValidationProblemDetailsFromDiscriminatorValue, serializeAgGridClientQuery, serializePagingResponseOfDashboardFile, type AgGridClientQuery, type PagingResponseOfDashboardFile, type ValidationProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Dashboard/Get
 */
export interface GetRequestBuilder extends BaseRequestBuilder<GetRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagingResponseOfDashboardFile>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     post(body: AgGridClientQuery, requestConfiguration?: RequestConfiguration<GetRequestBuilderPostQueryParameters> | undefined) : Promise<PagingResponseOfDashboardFile | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: AgGridClientQuery, requestConfiguration?: RequestConfiguration<GetRequestBuilderPostQueryParameters> | undefined) : RequestInformation;
}
export interface GetRequestBuilderPostQueryParameters {
    showOnlyAssignedToMe?: boolean;
    showOnlyDeparturesWithinWeek?: boolean;
    showOnlyErrors?: boolean;
    showPastDepartures?: boolean;
}
/**
 * Uri template for the request builder.
 */
export const GetRequestBuilderUriTemplate = "{+baseurl}/Dashboard/Get?showOnlyAssignedToMe={showOnlyAssignedToMe}&showOnlyDeparturesWithinWeek={showOnlyDeparturesWithinWeek}&showOnlyErrors={showOnlyErrors}&showPastDepartures={showPastDepartures}";
/**
 * Metadata for all the requests in the request builder.
 */
export const GetRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: GetRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagingResponseOfDashboardFileFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAgGridClientQuery,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
